import React from 'react';
import ReactDOM from 'react-dom';
import FacebookLogin from 'react-facebook-login';
const responseFacebook=(response)=> {
}

const Facebook = () => {
  return(

    <FacebookLogin
    appId="4414336575348322"
    autoLoad={true}
    fields="name,email,picture"
    scope="instagram_basic,pages_show_list,instagram_manage_insights"
    callback={responseFacebook}
  />
  );

}

export default Facebook